module.exports = __webpack_public_path__ + "static/media/mm.1809db77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mm.svg
// module id = 191
// module chunks = 0